<div [formGroup]="formGroup" class="form-group {{inline === true ? 'row inline-from-row' : ''}}">
  <label class="{{inline === true ? 'col-3' : ''}} col-form-label">{{label}}</label>
  <div [ngClass]="(inline === true ? 'col-9' : '')">
    <div class="input-group input-group-sm">
      <input class="form-control {{ (error !== '' && error !== undefined && error !== null ? 'is-invalid' : '') }}" placeholder="{{placeHolder}}"
        [minDate]="minDate" [maxDate]="maxDate" ngbDatepicker (ngModelChange)="change()" #d="ngbDatepicker"
        readonly="readonly" [formControlName]="formControlNameValue" name="{{name}}" id="{{id}}">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary btn-sm" (click)="d.toggle()" type="button"><i
            class="fa fa-calendar"></i></button>
      </div>
      <div class="invalid-feedback" [hidden]="error === '' && error === undefined && error === null">
        {{error | translate}}
      </div>
    </div>
  </div>
  <small class="form-text text-muted {{inline === true ? 'col-12' : ''}}" [hidden]="helpText === ''">
    {{helpText}}
  </small>
</div>